var map = {
	"./1.mp3": [
		646,
		646
	],
	"./10.mp3": [
		763,
		763
	],
	"./2.mp3": [
		952,
		952
	],
	"./3.mp3": [
		692,
		692
	],
	"./4.mp3": [
		408,
		408
	],
	"./5.mp3": [
		980,
		980
	],
	"./6.mp3": [
		334,
		334
	],
	"./7.mp3": [
		378,
		378
	],
	"./8.mp3": [
		62,
		826
	],
	"./9.mp3": [
		919,
		919
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 391;
module.exports = webpackAsyncContext;